module.exports = __webpack_public_path__ + "HCO.56fddda808b4069648b7.png";